interface PSReportHeaderProps {
  url: string | undefined;
  checkName: string;
}
export const PSReportHeader = ({url, checkName}: PSReportHeaderProps) => (
  <div key="report-title" className="row mb-3">
    <div className="col">
      <h2 className="mb-0">
        Performance report{" "}
        {url && (
          <span>
            for: <span className="text-success">{url}</span>
          </span>
        )}
      </h2>
      {checkName && <div className="mb-0 fw-normal text-muted fs-5">Check name: {checkName}</div>}
    </div>
  </div>
);
